import * as React from 'react';
import SVGIcon from '../SVGIcon';

const CarouselDisplayTypeChoice: React.FC = () => {
  return (
    <SVGIcon width="129" height="56" viewBox="0 0 129 56" fill="none">
      <>
        <g clipPath="url(#clip0_5483_3209)">
          <rect
            x="10.9995"
            y="0.523438"
            width="33.3753"
            height="27.2583"
            rx="0.536581"
            fill="#DDDDDD"
          />
          <path
            d="M10.9995 1.06002C10.9995 0.763673 11.2397 0.523438 11.5361 0.523438H43.8383C44.1346 0.523438 44.3749 0.763673 44.3749 1.06002V10.5312H10.9995V1.06002Z"
            fill="#9A9A9A"
          />
          <path d="M33.02 21.4766H42.3358V26.1685H33.02V21.4766Z" fill="#9A9A9A" />
        </g>
        <g clipPath="url(#clip1_5483_3209)">
          <rect
            x="47.9995"
            y="0.523438"
            width="33.3753"
            height="27.2583"
            rx="0.536581"
            fill="#DDDDDD"
          />
          <path
            d="M47.9995 1.06002C47.9995 0.763673 48.2397 0.523438 48.5361 0.523438H80.8383C81.1346 0.523438 81.3749 0.763673 81.3749 1.06002V10.5312H47.9995V1.06002Z"
            fill="#9A9A9A"
          />
          <path d="M70.02 21.4766H79.3358V26.1685H70.02V21.4766Z" fill="#9A9A9A" />
        </g>
        <g clipPath="url(#clip2_5483_3209)">
          <rect
            x="83.9995"
            y="0.523438"
            width="33.3753"
            height="27.2583"
            rx="0.536581"
            fill="#DDDDDD"
          />
          <path
            d="M83.9995 1.06002C83.9995 0.763673 84.2397 0.523438 84.5361 0.523438H116.838C117.135 0.523438 117.375 0.763673 117.375 1.06002V10.5312H83.9995V1.06002Z"
            fill="#9A9A9A"
          />
          <path d="M106.02 21.4766H115.336V26.1685H106.02V21.4766Z" fill="#9A9A9A" />
        </g>
        <path
          d="M5.1733 18.8828L5.68506 18.3711L2.0249 14.7109L5.68506 11.0507L5.1733 10.539L1.25726 14.455L1.01251 14.7109L1.25726 14.9668L5.1733 18.8828Z"
          fill="#212121"
          stroke="#555555"
        />
        <path
          d="M123.511 10.5391L123 11.0508L126.66 14.711L123 18.3711L123.511 18.8829L127.427 14.9669L127.672 14.711L127.427 14.4551L123.511 10.5391Z"
          fill="#212121"
          stroke="#555555"
        />
        <defs>
          <clipPath id="clip0_5483_3209">
            <rect
              x="10.9995"
              y="0.523438"
              width="33.3753"
              height="27.2583"
              rx="1.66877"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_5483_3209">
            <rect
              x="47.9995"
              y="0.523438"
              width="33.3753"
              height="27.2583"
              rx="1.66877"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip2_5483_3209">
            <rect
              x="83.9995"
              y="0.523438"
              width="33.3753"
              height="27.2583"
              rx="1.66877"
              fill="white"
            />
          </clipPath>
        </defs>
      </>
    </SVGIcon>
  );
};

export default CarouselDisplayTypeChoice;
